
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useSysItemList } from '@/modules/item/system/model/list';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { InjectionFeature, RewardFeatures } from '@/common/reward/types';
import { getRewardRouteToIndexPage } from '@/common/reward/route.registry';

export default defineComponent({
    name: ROUTE_NAME_ITEM.SYSTEM.INDEX,
    components: { AppTable, AppCard, AppFormRow, AppSelect, AppInput, AppButton },
    setup() {
        const { selectedFeature, query, v$, list, total, fetchList, actions, appSelectOptionsWithAll } =
            useSysItemList();
        const selectableFeatures = RewardFeatures.filter(f => f.value != InjectionFeature.AvatarBackground);

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Ruby', key: 'ruby' },
                { type: TableColumnType.Option, label: 'Feature', key: 'feature', options: selectableFeatures },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Text, label: 'App (current cycle)', key: 'curAppNames' },
                { type: TableColumnType.Text, label: 'App (next cycle)', key: 'nextAppNames' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_ITEM.SYSTEM.EDIT, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_ITEM.SYSTEM.TRANSLATE, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-link',
                        theme: 'info',
                        tooltip: 'Link',
                        to: { name: ROUTE_NAME_ITEM.SYSTEM.LINK, params: { itemId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return {
            selectedFeature,
            query,
            list,
            total,
            v$,
            table,
            fetchList,
            actions,
            appSelectOptionsWithAll,
            selectableFeatures,
            getRewardRouteToIndexPage
        };
    }
});
